import { SwitchField } from 'components';

export const RandomizeOptionsField = ({ name }: { name: string }) => (
  <div className="self-start">
    <SwitchField
      label="Randomize answer options"
      name={`${name}.options.randomize`}
    />
  </div>
);
